<ul [ngClass]="className()" class="flex flex-col">
	@for (link of linkListItems(); track $index) {
		<li
			[attr.data-test-id]="link.id"
			[ngClass]="{
				'border-ui-75': !$last && showDivider(),
				'border-t': $first && showBorderTop(),
				'border-t-ui-75': linkListItems().length === 1 && showDivider(),
			}"
			class="border-b border-transparent bg-white hover:bg-ui-25"
			data-test-class="list-item"
		>
			<valk-core-smart-link
				[className]="'flex flex-row items-center p-4 hover:text-black'"
				[rel]="link.targetSelf ? undefined : 'noopener noreferrer'"
				[target]="link.targetSelf ? '_self' : '_blank'"
				[url]="link.url"
				data-test-class="link-list-item"
			>
				<ng-container
					[ngTemplateOutlet]="linkContent"
					[ngTemplateOutletContext]="{ link: link }"
				/>
			</valk-core-smart-link>
		</li>
	}
</ul>

<ng-template #linkContent let-link="link">
	@if (showIcons() && link.icon) {
		<div class="mr-2 flex">
			<svg-icon [src]="link.icon" class="size-4" />
		</div>
	}
	<span class="flex text-base md:text-lg">
		{{ link.text | translate }}
	</span>
	@if (useChevron()) {
		<div class="ml-auto flex" data-test-class="chevron">
			<svg-icon
				class="size-4"
				src="assets/icons/icon-chevron-right.svg"
			/>
		</div>
	}
	@if (link.tagText && !useChevron()) {
		<div
			class="ml-auto w-fit justify-end whitespace-nowrap"
			data-test-class="tag"
		>
			<vp-tag color="accent">{{ link.tagText }}</vp-tag>
		</div>
	}
</ng-template>
